import React, { useState, useRef, useEffect } from 'react';
import { debugLog } from '../utils/debugLog.js';
import VercelBody from './VercelBody';
import { generateChartImages, getChartImageCardHtml, processEmailStyles } from './emailPreprocessor';
import EmailPreview from './EmailPreview.jsx';

// Sample data for testing
const sampleData = {
  totalSavings: 1500,
  monthlySavings: 125,
  savingsBreakdown: [
    { category: 'Infrastructure', amount: 750 },
    { category: 'Development', amount: 450 },
    { category: 'Operations', amount: 300 }
  ],
  chartData: {
    labels: ['Infrastructure', 'Development', 'Operations'],
    datasets: [
      {
        data: [750, 450, 300],
        backgroundColor: ['#4F46E5', '#7C3AED', '#EC4899']
      }
    ]
  }
};

export function EmailPrototypePage() {
  const [previewMode, setPreviewMode] = useState('desktop');
  const [sending, setSending] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const chartRef = useRef(null);
  const cardRef = useRef(null);
  const emailContainerRef = useRef(null);
  const [emailHtml, setEmailHtml] = useState('');
  const [loading, setLoading] = useState(true);

  const handleSendTestEmail = async () => {
    setSending(true);
    setError(null);
    setSuccess(false);

    try {
      debugLog('Starting email send process...');
      debugLog('Chart ref exists:', !!chartRef.current);
      debugLog('Card ref exists:', !!cardRef.current);
      debugLog('Email container ref exists:', !!emailContainerRef.current);

      // Generate both images
      const { chartImageSvg } = await generateChartImages({
        chartElement: chartRef.current,
        cardElement: cardRef.current,
      });
      debugLog('chartImageSvg:', chartImageSvg);

      // Use static HTML template and insert chartImageSvg in place of SVG
      let emailHtml = ``;

      // Send the email
      debugLog('Sending email...');
      const response = await fetch('/api/sendEmail', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          to: 'will@upgraded.com',
          subject: 'Test Email - Upgraded Savings Report',
          html: emailHtml,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        console.error('Email send failed:', errorData);
        throw new Error(errorData.error || `Failed to send email: ${response.status} ${response.statusText}`);
      }

      const result = await response.json();
      debugLog('Email sent successfully:', result);
      setSuccess(true);
    } catch (err) {
      console.error('Error in handleSendTestEmail:', err);
      setError(err.message || 'An unexpected error occurred while sending the email');
    } finally {
      setSending(false);
    }
  };

  useEffect(() => {
    async function fetchEmailHtml() {
      setLoading(true);
      try {
        // You can pass a domain if you want real data, or leave blank for sample
        const res = await fetch('/api/email-preview?domain=getupgraded.ca');
        const html = await res.text();
        setEmailHtml(html);
      } catch (err) {
        setEmailHtml('<p>Error loading email preview</p>');
      } finally {
        setLoading(false);
      }
    }
    fetchEmailHtml();
  }, []);

  return (
    <div>
      <h2>Email Template Preview (Real Backend Data)</h2>
      {loading ? <div>Loading...</div> : (
        <div dangerouslySetInnerHTML={{ __html: emailHtml }} />
      )}
    </div>
  );
}

export default EmailPrototypePage; 